import { render, staticRenderFns } from "./cataractnnvmpMobile.vue?vue&type=template&id=5e71f9c6"
import script from "./cataractnnvmpMobile.vue?vue&type=script&lang=js"
export * from "./cataractnnvmpMobile.vue?vue&type=script&lang=js"
import style0 from "./cataractnnvmpMobile.vue?vue&type=style&index=0&id=5e71f9c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports